const optimizerDefaultHeader = [
  {
    group: 'Parametro Default',
    columns: [
      {
        name: 'Curva',
        id: 'default-nome',
        show: true
      },
      {
        name: 'Minimo',
        id: 'default-min',
        show: true
      },
      {
        name: 'Maximo',
        id: 'default-max',
        show: true
      },
      {
        name: 'Default',
        id: 'default-default',
        show: true
      }
    ]
  }
]

export default optimizerDefaultHeader
